import { useState, useEffect } from "react";
import { pagesAPI } from "../api/endpoints";

// Maps route key to the field name in PoliciesResponse and display title
const pageConfig = {
  "privacy-policy": { field: "privacy_policy", title: "Privacy Policy" },
  "terms-of-service": { field: "terms_of_service", title: "Terms of Service" },
  "copyright": { field: "copy_right", title: "Copyright" },
  "advertising-policy": { field: "advertising_policy", title: "Advertising Policy" },
  "cookies-policy": { field: "cookies_policy", title: "Cookies Policy" },
};

export default function StaticPage({ pageKey }) {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  const config = pageConfig[pageKey];

  useEffect(() => {
    if (!config) return;
    setLoading(true);
    pagesAPI
      .getPolicies()
      .then((res) => {
        const html = res.data?.[config.field] || null;
        setContent(html);
      })
      .catch(() => setContent(null))
      .finally(() => setLoading(false));
  }, [pageKey]);

  if (loading) {
    return (
      <div className="min-h-screen bg-dark-900 flex items-center justify-center pt-16">
        <div className="w-10 h-10 border-3 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-dark-900 pt-20 pb-16">
      <div className="max-w-3xl mx-auto px-5 md:px-10">
        <h1 className="text-2xl md:text-3xl font-bold text-white mb-8">
          {config?.title || "Page"}
        </h1>

        {content ? (
          <div
            className="policy-content prose prose-invert prose-sm max-w-none"
            dangerouslySetInnerHTML={{ __html: content }}
          />
        ) : (
          <p className="text-gray-500 py-10 text-center">Content not available</p>
        )}
      </div>
    </div>
  );
}
